import React from "react";
import Link from "./global/Link";
import {NavDropdown} from "react-bootstrap";
import {useMenuItems} from "./_hooks/useMenuItems";

export const Menu = () => {
  const menuItems = useMenuItems('DESKTOP_NAV');

  return menuItems ? (
    <ul className="navbar-nav me-lg-auto mb-2 mb-lg-0">
      {menuItems.map((menuItem, index) => {
        const key = menuItem.id + index;

          return menuItem.children.length ?
            <li className="nav-item me-lg-2 me-xl-3" key={key}>
              <NavDropdown title={menuItem.label} id={menuItem.id} menuVariant="dark" renderMenuOnMount={true}>
                {menuItem.children && menuItem.children.map((childrenItem, index) => (
                  <Link key={childrenItem.id + index} className="nav-link" to={childrenItem.url}>{childrenItem.label}</Link>
                ))}
              </NavDropdown>
            </li>
            :
            <li className="nav-item me-lg-4" key={key}>
              <Link className="nav-link" to={menuItem.url} target={menuItem.target}>{menuItem.label}</Link>
            </li>
        }
      )}
    </ul>
  ) : null;
}
